var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1, 3) scale(0.99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.0693 75.4863C91.0693 89.0974 81.114 100.491 67.7363 102.437V114.376H59.958V102.437C56.8169 101.98 53.8647 101.002 51.1855 99.5967L57.0723 93.71C59.2201 94.5085 61.5121 94.9307 63.8477 94.9307C66.401 94.9306 68.9291 94.4273 71.2881 93.4502C73.6472 92.4731 75.7911 91.041 77.5967 89.2354C79.4021 87.4299 80.8344 85.2866 81.8115 82.9277C82.7886 80.5686 83.292 78.0398 83.292 75.4863H91.0693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.806 114.376H97.5547L95.6963 109.557H88.1777L86.3193 114.376H83.0391L90.1807 95.6797H93.7227L100.806 114.376ZM88.6709 107.118H95.1738L91.9229 98.5537L88.6709 107.118Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.078 114.376H103.914V95.6797H107.078V114.376Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4023 75.4863C44.4023 80.6432 46.4513 85.5889 50.0977 89.2354C50.3766 89.5143 50.6644 89.783 50.958 90.043L45.4414 95.5596C39.9928 90.5661 36.625 83.4016 36.625 75.4863H44.4023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.803 78.2793L117.079 81.0078L109.803 83.7363L107.075 91.0127L104.346 83.7363L97.0703 81.0078L104.346 78.2793L107.075 71.0039L109.803 78.2793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5137 75.4863C75.5137 78.5805 74.2846 81.5484 72.0967 83.7363C69.9089 85.924 66.9416 87.1532 63.8477 87.1533C63.7768 87.1533 63.7055 87.1487 63.6348 87.1475L75.5137 75.2695V75.4863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8477 40.4863C66.9416 40.4864 69.9089 41.7156 72.0967 43.9033C74.2846 46.0912 75.5137 49.0591 75.5137 52.1533V65.4883L56.4736 84.5273C56.1699 84.2796 55.8773 84.0159 55.5977 83.7363C53.4097 81.5484 52.1807 78.5805 52.1807 75.4863V52.1533C52.1807 49.0591 53.4097 46.0912 55.5977 43.9033C57.7856 41.7154 60.7535 40.4863 63.8477 40.4863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.985 55.4395L117.079 59.5996L105.985 63.7598L101.824 74.8545L97.6641 63.7598L89.9248 60.8574L93.9512 56.8311L97.6641 55.4395L99.0557 51.7266L103.082 47.7002L105.985 55.4395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3291 42.6836L94.7617 44.3457L90.3291 46.0088L88.666 50.4414L87.0039 46.0088L82.5703 44.3457L87.0039 42.6836L88.666 38.25L90.3291 42.6836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76 8C113.003 8.00001 143 37.9969 143 75C143 112.003 113.003 142 76 142C38.9969 142 8.99998 112.003 9 75C9.00002 37.9969 38.9969 8 76 8ZM76 13C41.7584 13 14 40.7583 14 75C14 109.242 41.7584 137 76 137C110.242 137 138 109.242 138 75C138 40.7583 110.242 13 76 13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6665 121.746C29.2984 121.334 29.3166 120.683 29.7071 120.293L121.177 28.8227C121.568 28.4322 122.183 28.4494 122.551 28.8611L125.835 32.5344C126.203 32.9461 126.185 33.5965 125.794 33.987L34.3241 125.457C33.9336 125.848 33.3186 125.83 32.9505 125.419L29.6665 121.746Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.d4ea47c38679289ce2ab4613300d5ede.svg";
export { ForwardRef as ReactComponent };